module.exports = __webpack_public_path__ + "static/img/mt_signal5.aa260d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/mt_signal5.png
// module id = 6MkQ
// module chunks = 4